import { sectionLabels } from "../section-labels";
import { appearanceFields, dividerField, secondaryButtonFields, } from "./_shared";
/**
 * Top-seller section — the design's "FeatureB" big 4:5 product spotlight.
 * Sits between Collections and Stories on the home page by default.
 *
 * Locked + maxPerTemplate: 1 so the section list always shows exactly one
 * instance the seller can hide / edit.
 *
 * Leaving `productId` empty hands the choice to the CATALOG: the storefront
 * list is ordered featured-first, so the spotlight becomes whatever the
 * merchant featured on the products page — and changes when they change it,
 * with no design publish. A store that has featured nothing still gets the
 * first product with an image, exactly as before. Setting `productId` is the
 * override: an explicit pick here always wins.
 */
export const topSellerSchema = {
    type: "top-seller",
    name: sectionLabels["top-seller"],
    description: {
        ar: "منتج واحد بصورة كبيرة وزر شراء سريع. يظهر بين قسم الفئات والقصص.",
        en: "A single hero product with a big image and a quick add-to-bag CTA.",
    },
    // Unlocked: deletable + re-addable from the editor's "+ Add section" picker.
    maxPerTemplate: 1,
    availableOnTemplates: ["home"],
    settings: [
        {
            id: "productId",
            type: "productPicker",
            maxItems: 1,
            label: { ar: "المنتج", en: "Product" },
            helpText: {
                ar: "سيبه فاضي عشان ياخد المنتج المميز الأول من صفحة المنتجات.",
                en: "Leave empty to follow your featured products from the Products page.",
            },
        },
        {
            id: "eyebrow",
            type: "text",
            i18n: true,
            label: { ar: "نص صغير فوق العنوان", en: "Eyebrow label" },
            helpText: {
                ar: 'النص الصغير فوق اسم المنتج. الافتراضي "TOP SELLER".',
                en: 'Small label above the product name. Defaults to "TOP SELLER".',
            },
            validate: { max: 30 },
        },
        {
            id: "headingLevel",
            type: "headingLevel",
            label: { ar: "مستوى العنوان", en: "Heading level" },
            default: 2,
        },
        {
            id: "imageFit",
            type: "select",
            label: { ar: "ملء الصورة", en: "Image fit" },
            helpText: {
                ar: "احتواء: تظهر الصورة كاملة. تغطية: تملأ الإطار مع قص.",
                en: "Contain shows the whole image; cover fills the frame (cropped).",
            },
            options: [
                { value: "contain", label: { ar: "احتواء", en: "Contain" } },
                { value: "cover", label: { ar: "تغطية", en: "Cover" } },
            ],
            default: "contain",
        },
        dividerField(),
        ...appearanceFields(),
        ...secondaryButtonFields(),
    ],
};
//# sourceMappingURL=top-seller.js.map